export * from './search-modal/search-modal.component';
export * from './detail-modal/detail-modal.component';
